export enum LoginConstants {
  USER_SET_IS_AUTORIZED = "USER_SET_IS_AUTORIZED",
  SET_PASSWORD = "SET_PASSWORD",
}
